import { cn } from "@/lib/utils";

interface ProgressProps {
  value: number; // 0..1
  className?: string;
  barClassName?: string;
}

/** Simple progress bar. value is clamped to [0, 1]. */
export function Progress({ value, className, barClassName }: ProgressProps) {
  const pct = Math.max(0, Math.min(1, value)) * 100;
  return (
    <div
      className={cn(
        "h-1.5 w-full overflow-hidden rounded-full bg-muted",
        className,
      )}
    >
      <div
        className={cn(
          "h-full rounded-full bg-primary transition-all",
          barClassName,
        )}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
